import { searchPublishersSuggestions, getPublisherSuggestions } from '@App/api/routes/search'
import { AutoCompleteFetchRequest } from '@App/stores/search/models/select-option-hide'

const getPublisherNameAutoCompleteSuggestions = async ({
    searchTerm,
    rightsholderId,
    signal,
}: AutoCompleteFetchRequest) => {
    const normalizedProperty = 'fullName'
    let suggestions
    if (rightsholderId) {
        suggestions = await getPublisherSuggestions(rightsholderId, normalizedProperty, searchTerm, signal)
    } else {
        suggestions = await searchPublishersSuggestions(normalizedProperty, searchTerm, signal)
    }
    return suggestions.data || []
}

export default getPublisherNameAutoCompleteSuggestions
